if (!customElements.get('trust-indicators-slider')) {
  class TrustIndicatorsSlider extends HTMLElement {
    constructor() {
      super();

      const swiperOptions = JSON.parse(this.getAttribute('data-swiper-options')) || {};
      
      this.initSlider(swiperOptions);
    }

    initSlider(swiperOptions) {
      this.slider = new Swiper(this, {
        slidesPerView: swiperOptions.slidesPerView || 1,
        spaceBetween: swiperOptions.spaceBetweenMobile || 0,
        autoplay: swiperOptions.autoplay || false,
        breakpoints: {
          0: {
            enabled: true,
            spaceBetween: swiperOptions.spaceBetweenMobile || 0,
            slidesPerView: 1,
            loop: true
          },
          1400: {
            enabled: true,
            spaceBetween: swiperOptions.spaceBetweenDesktop || 0,
            slidesPerView: 4,
            loop: false
          }
        }
      });
    }
  }

  customElements.define('trust-indicators-slider', TrustIndicatorsSlider);
}
